import React, { Component } from "react";
import { CRUDFunction } from "../../../reduxCURD/container";
import { curdActions } from "../../../reduxCURD/actions";
import { getAllUsersList } from "../../../reduxRelated/actions/userActions";
import TourUserAssignment from "./TourUserAssignment";
import InspectionSelector from "./InspectionSelector"; // New import
import { MyButton } from "../../Common/Forms/formsMiscItems";
import "./TourDetails.css";
import { languageService } from "../../../Language/language.service";
import SpinnerLoader from "../../Common/SpinnerLoader";
import { Fragment } from "react";
class TourDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inspectionList: [],
      allUsers: [],
      isLoading: false,
    };
  }
  componentDidMount() {
    const { getAllUsersList, getTourDetailss, allowEdit, selectedTour } = this.props;
    const { opt1 } = selectedTour && selectedTour;
    const { templateIds } = opt1 && opt1;
    let roles = ["inspector", "manager", "maintenance", "supervisor", "admin"];
    let ids = (templateIds || []).join(",");
    getAllUsersList && getAllUsersList({ roles: roles, filterRemoved: true });
    getTourDetailss && allowEdit ? getTourDetailss() : ids.length > 0 && getTourDetailss(`list/${ids}`);
  }
  componentDidUpdate(prevProps) {
    const { actionType, userActionType, allUsers, TourDetailss, allowEdit, selectedTour, getTourDetailss } = this.props;
    var prevSelected = prevProps.selectedTour;
    var currSelected = this.props.selectedTour;

    var prevCode = prevSelected ? prevSelected.code : null;
    var currCode = currSelected ? currSelected.code : null;

    var prevTemplateIds = prevSelected && prevSelected.opt1 && prevSelected.opt1.templateIds ? prevSelected.opt1.templateIds.join(",") : "";

    var currTemplateIds = currSelected && currSelected.opt1 && currSelected.opt1.templateIds ? currSelected.opt1.templateIds.join(",") : "";
    if (prevProps.allowEdit !== allowEdit && allowEdit) {
      const { opt1 } = selectedTour && selectedTour;
      const { templateIds } = opt1 && opt1;
      let ids = (templateIds || []).join(",");
      getTourDetailss && allowEdit ? getTourDetailss() : ids.length > 0 && getTourDetailss(`list/${ids}`);
    }
    if (prevCode !== currCode) {
      var ids = currTemplateIds;

      if (this.props.getTourDetailss) {
        if (this.props.allowEdit) {
          this.props.getTourDetailss();
        } else if (ids && ids.length > 0) {
          this.props.getTourDetailss("list/" + ids);
        }
      }
    }
    if (prevProps.actionType !== actionType && actionType === "TOURDETAILSS_READ_REQUEST") {
      this.setState({
        isLoading: true,
      });
    }
    if (userActionType !== prevProps.userActionType && userActionType === "ALL_USER_LIST_REQUEST") {
      this.setState({
        isLoading: true,
      });
    }
    if (prevProps.actionType !== actionType && actionType === "TOURDETAILSS_READ_FAILURE") {
      this.setState({
        isLoading: false,
      });
    }
    if (userActionType !== prevProps.userActionType && userActionType === "ALL_USER_LIST_FAILURE") {
      this.setState({
        isLoading: false,
      });
    }
    if (prevProps.actionType !== actionType && actionType === "TOURDETAILSS_READ_SUCCESS") {
      this.setState({
        inspectionList: TourDetailss,
        isLoading: false,
      });
    }
    if (userActionType !== prevProps.userActionType && userActionType === "ALL_USER_LIST_SUCCESS") {
      this.setState({
        allUsers: allUsers,
        isLoading: false,
      });
    }
  }

  render() {
    const {
      allowEdit,
      selectedTour,
      onDescriptionChange,
      onAddInspection,
      onUserAssignmentChange,
      onSaveTourDetails,
      allUsers,
      mode,
      handleEditTour,
      handleCancelEditingTour,
      editPermission,
    } = this.props;

    // Ensure selectedTour is not null before rendering details
    if (!selectedTour) {
      return (
        <div style={{ border: "1px solid #ccc", padding: "10px", minHeight: "200px" }}>
          {languageService("Select a tour to view details.")}
        </div>
      );
    }
    let inspectionList = this.state.inspectionList.map((insp) => ({ id: insp._id, name: insp.title }));
    inspectionList = mode === "edit" ? inspectionList : inspectionList.filter((i) => (selectedTour.opt1.templateIds || []).includes(i.id));

    return (
      <Fragment>
        <SpinnerLoader spinnerLoading={this.state.isLoading} />
        <div style={{ border: "1px solid var(--first)", padding: "10px", minHeight: "200px", overflowY: "auto" }}>
          <div className="tour-details-header">
            <h5>{languageService(selectedTour.description)}</h5>
            {editPermission &&
              (allowEdit && mode === "edit" ? (
                <div style={{ display: "flex", gap: "5px" }}>
                  <MyButton customStyle={{ marginBottom: "0px" }} onClick={handleCancelEditingTour}>
                    {languageService("Cancel")}
                  </MyButton>
                  <MyButton customStyle={{ marginBottom: "0px" }} onClick={onSaveTourDetails}>
                    {languageService("Save")}
                  </MyButton>
                </div>
              ) : (
                <MyButton customStyle={{ marginBottom: "0px" }} onClick={handleEditTour}>
                  {languageService("Edit")}
                </MyButton>
              ))}
          </div>

          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
            <div style={{ width: allowEdit ? "35vw" : "100%", display: "flex", gap: "30px" }}>
              <label style={{ fontSize: "14px", width: allowEdit ? "135px" : "80px" }}>
                <strong>
                  {languageService("Description")}:{allowEdit ? " *" : " "}
                </strong>
              </label>
              {allowEdit ? (
                <input
                  type="text"
                  value={selectedTour && selectedTour.opt1.description}
                  onChange={(e) => onDescriptionChange(e.target.value)}
                  readOnly={!allowEdit}
                  style={{ width: "100%", padding: "5px", fontSize: "12px" }}
                />
              ) : (
                <div>{selectedTour && selectedTour.opt1.description}</div>
              )}
            </div>
          </div>
          <div style={{ display: "flex", height: "calc(100% - 50px)" }}>
            {/* Section 1: Tour Content */}
            <div style={{ flex: "0 0 30%", paddingRight: "10px", overflowY: "auto", borderRight: "2px solid #ccc" }}>
              <div style={{ display: "flex", height: "100%", flexDirection: "column" }}>
                <div className="user-assignment-heading">
                  <label>
                    <strong>{languageService("Inspection Assignment")}</strong>
                  </label>
                </div>

                <InspectionSelector
                  options={inspectionList}
                  selected={selectedTour.opt1 ? selectedTour.opt1.templateIds : []}
                  onChange={onAddInspection}
                  allowEdit={allowEdit}
                />
              </div>
            </div>
            {/* Section 2: User Assignment */}
            <div style={{ flex: "0 0 70%", paddingLeft: "10px", overflowY: "auto" }}>
              <TourUserAssignment
                tourCode={selectedTour.code}
                allUsers={allUsers || []}
                prmUsers={selectedTour.opt1 ? selectedTour.opt1.prmUsers : []}
                scndUsers={selectedTour.opt1 ? selectedTour.opt1.scndUsers : []}
                allowEdit={allowEdit}
                onUserAssignmentChange={onUserAssignmentChange}
              />
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

let variableList = {
  userReducer: {
    usersSignatures: [],
    allUsers: [],
  },
};
let actionOptions = {
  read: true,
  others: {
    getAllUsersList,
  },
};

const TourDetailContainer = CRUDFunction(TourDetails, "TourDetails", actionOptions, variableList, ["userReducer"], "workPlanTemplate");
export default TourDetailContainer;



// WEBPACK FOOTER //
// ./src/components/Tour/TourDetails/index.jsx